module.exports = __webpack_public_path__ + "static/img/advantage3.e1d006cb.png";